import React, { useCallback, useEffect, useState } from "react";
import { fetchPersonaResult } from "./api/personaApi";
import PersonaRequestForm from "./components/PersonaRequestForm";
import PersonaResponseView from "./components/PersonaResponseView";
import { preparePersonaPayload } from "./utils/personaTransform";
import "./PersonaFetchPage.css";

function loadClientsFromLoginDetails() {
  const raw = localStorage.getItem("loginDetails");
  if (!raw) return [];

  try {
    const loginDetails = JSON.parse(raw);
    if (!loginDetails || typeof loginDetails !== 'object') return [];
    const list = Array.isArray(loginDetails?.clientData) ? loginDetails.clientData : [];
    const uniqueMap = new Map();

    list.forEach((entry) => {
      const clientId = (entry?.clientId || "").trim();
      if (!clientId || uniqueMap.has(clientId)) return;
      uniqueMap.set(clientId, {
        clientId,
        org: entry?.org || "",
        center: entry?.center || "",
        customerName: entry?.org || entry?.center || clientId,
        displayName: entry?.org || entry?.center || clientId,
      });
    });

    return Array.from(uniqueMap.values()).sort((a, b) =>
      (a.customerName || a.clientId).localeCompare(b.customerName || b.clientId)
    );
  } catch (_) {
    return [];
  }
}

const PersonaFetchPage = () => {
  const [clients, setClients] = useState([]);
  const [clientsError, setClientsError] = useState("");
  const [clientsSource] = useState("session");

  const [fetchingPersona, setFetchingPersona] = useState(false);
  const [personaError, setPersonaError] = useState("");
  const [personaPayload, setPersonaPayload] = useState(null);

  const loadClients = useCallback(() => {
    setClientsError("");

    const sessionClients = loadClientsFromLoginDetails();
    setClients(sessionClients);
    if (!sessionClients.length) {
      setClientsError("No clients found in admin login response (loginDetails.clientData).");
    }
  }, []);

  useEffect(() => {
    loadClients();
  }, []);

  const handleFetchPersona = useCallback(async ({ clientId, labNo }) => {
    setFetchingPersona(true);
    setPersonaError("");

    try {
      const response = await fetchPersonaResult({ clientId, labNo });
      const transformed = preparePersonaPayload(response);
      setPersonaPayload(transformed);
    } catch (error) {
      setPersonaPayload(null);
      setPersonaError(error?.message || "Failed to fetch persona response.");
    } finally {
      setFetchingPersona(false);
    }
  }, []);

  return (
    <main className="persona-fetch-page">


      <PersonaRequestForm
        clients={clients}
        clientsLoading={false}
        clientsError={clientsError}
        clientsSource={clientsSource}
        isFetching={fetchingPersona}
        onRetryClients={loadClients}
        onFetch={handleFetchPersona}
      />

      <PersonaResponseView payload={personaPayload} error={personaError} />
    </main>
  );
};

export default PersonaFetchPage;
